module.exports = __webpack_public_path__ + "img/237.7a4a19d2.png";